/* eslint-disable jsx-a11y/control-has-associated-label */
import {
  AdsClickOutlined,
  HomeOutlined,
  Menu,
  MoveUp,
} from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import {
  ReactNode,
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
} from "react";
import { Logo } from "../Logo";

interface IMenuItems {
  label: string;
  icon: ReactNode;
  link: string;
}

export function MasterPageSidebar() {
  const [showSidebar, setShowSidebar] = useState<boolean>(false);

  const updateLS = useCallback((v: string) => {
    localStorage.setItem("showSidebar", v);
  }, []);

  const onToggleSidebar = useCallback(() => {
    setShowSidebar((prevState) => !prevState);
  }, []);

  useLayoutEffect(() => {
    const lsItem = localStorage.getItem("showSidebar");
    setShowSidebar(lsItem === "true");
  }, []);

  useEffect(() => {
    return () => {
      updateLS(showSidebar.toString());
    };
  }, [showSidebar, updateLS]);

  const menuItems: IMenuItems[] = useMemo(() => {
    const iconStyle = ` text-white ${showSidebar ? "!text-lg" : "!text-2xl !-ml-1"}`;

    return [
      {
        label: "Dashboard",
        icon: <HomeOutlined className={iconStyle} />,
        link: "/dashboard",
      },
      {
        label: "Moderación de anúncios",
        icon: <AdsClickOutlined className={iconStyle} />,
        link: "/ads",
      },
      {
        label: "Transferir Inmuebles",
        icon: <MoveUp className={iconStyle} />,
        link: "/transfer-properties",
      },
    ];
  }, [showSidebar]);

  return (
    <aside className="relative flex items-start bg-[#3A3F52]">
      <div className="w-full sticky top-0 left-0 z-20">
        <div className="absolute -right-[45px] md:-right-[49px] lg:-right-[53px] top-3 z-[52]">
          <IconButton onClick={onToggleSidebar}>
            <Menu color="secondary" fontSize="medium" />
          </IconButton>
        </div>

        <button
          type="button"
          onClick={onToggleSidebar}
          className={`${showSidebar ? "w-screen md:w-0" : "w-0"} bg-black bg-opacity-65 h-screen z-[53] fixed top-0 left-0`}
        />

        <div
          className={`${showSidebar ? "min-w-[230px] max-w-[230px] left-0" : "-left-[230px] md:left-0 md:min-w-[80px] md:max-w-[80px]"} bg-[#3A3F52] z-[54] h-screen top-0 fixed md:relative flex flex-col justify-start transition-all duration-500`}
        >
          <header className="w-full min-h-16 max-h-16 overflow-hidden flex justify-center items-center content-center z-[51] shadow-header">
            <Link to="/">
              <Logo theme="white" />
            </Link>
          </header>

          <nav className="w-full flex flex-col box-border py-4 md:py-3 overflow-hidden">
            <ul className="w-full flex flex-col list-none">
              {menuItems.map((item: IMenuItems) => (
                <li key={`sidebarNav${item.label}`}>
                  <NavLink
                    to={item.link}
                    title={item.label}
                    className={({ isActive }) =>
                      `w-full bg-[#282D3F] ${isActive ? "bg-opacity-100 border-primary" : "bg-opacity-0 border-transparent hover:border-primary hover:bg-opacity-100"} box-border px-4 md:px-5 py-3 flex items-center border-l-[4px] transition-all duration-300 ${showSidebar ? "" : "justify-center"}`
                    }
                  >
                    {item.icon}

                    <span
                      className={`font-dmsans text-[15px] inline-flex text-white ml-2 whitespace-nowrap ${showSidebar ? "" : "hidden"}`}
                    >
                      {item.label}
                    </span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </aside>
  );
}

export default { MasterPageSidebar };
